import { useMutation } from "@tanstack/react-query";
import { api } from "../../../api";
import { MIGRATION } from "../../../constants/testIds";
import { SubmitButton } from "../../common/SubmitButton";

// SCR-P04-40 - applies a preset "standard budget gym" plan catalog. Idempotent - re-applying
// after the first run creates nothing new (verified by test_phase10_migration_studio.py).
export function ArchetypeTab() {
  const applyMutation = useMutation({ mutationFn: () => api.post("/migration/apply-archetype", { archetype: "standard_budget_gym" }) });
  const result = applyMutation.data?.data;

  return (
    <div className="solid-surface rounded-[14px] p-6 space-y-4">
      <div>
        <p className="text-sm font-semibold" style={{ color: "var(--scarlet-text)" }}>Standard budget gym archetype</p>
        <p className="text-xs mt-1" style={{ color: "var(--scarlet-text-secondary)" }}>
          Creates a starter plan catalog (Standard Monthly, Premium Monthly, 10-Class Pack) for gyms migrating without a plan structure of their own. Safe to run more than once - existing plans are never duplicated.
        </p>
      </div>
      <SubmitButton testId={MIGRATION.archetypeApplyButton} pending={applyMutation.isPending} onClick={() => applyMutation.mutate()} label="Apply archetype" />
      {result && (
        <div className="grid grid-cols-2 gap-3 pt-2">
          <div data-testid={MIGRATION.archetypeResultCreated} className="rounded-[10px] p-3 text-center" style={{ background: "var(--scarlet-surface-2)" }}>
            <p className="text-xl font-bold" style={{ color: "#3FA65B" }}>{result.plans_created.length}</p>
            <p className="text-xs" style={{ color: "var(--scarlet-text-secondary)" }}>Created</p>
          </div>
          <div data-testid={MIGRATION.archetypeResultExisting} className="rounded-[10px] p-3 text-center" style={{ background: "var(--scarlet-surface-2)" }}>
            <p className="text-xl font-bold" style={{ color: "#8B8B92" }}>{result.plans_already_existed.length}</p>
            <p className="text-xs" style={{ color: "var(--scarlet-text-secondary)" }}>Already existed</p>
          </div>
        </div>
      )}
    </div>
  );
}
